import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import config from 'app/src/config';
import { Button } from 'app/src/elements/buttons';
import { Fields } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';

const typeOptions = [
  {
    value: 'bug',
    label: 'Bug Report',
  },
  {
    value: 'feature',
    label: 'Feature Request',
  },
  {
    value: 'comment',
    label: 'General Comment',
  },
];

const FIELDS = {
  type: {
    label: 'Is this a...',
    select: typeOptions,
  },
  name: {
    label: 'Your Name',
    rules: { required: true },
  },
  email: {
    rules: { required: true },
  },
  subject: {
    label: "In just a few words, what isn't working correctly?",
    rules: { required: true },
  },
  bug: {
    label: 'Please describe in detail what went wrong',
    type: 'hidden',
  },
  expectation: {
    label: 'What were you expecting to happen?',
  },
};

const Ticket = ({ setShow }) => {
  const [submitting, setSubmitting] = useState();

  const {
    control, handleSubmit, watch, formState: { errors }
  } = useForm({
    defaultValues: {
      type: 'bug',
      name: '',
      email: '',
      subject: '',
      problem: '',
      expectation: '',
    }
  });

  const onSubmit = data => {
    const { type, ...values } = data;
    if ('bug' !== type) {
      values.subject = typeOptions.find(({ value }) => value === type).label +
        ': ' + values.subject;
    }

    fetch('https://preflighttech.com/api/1/trouble_tickets', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: config.pti.token,
      },
      body: JSON.stringify(values)
    }).then(() => setSubmitting('Thank you.'));

    setSubmitting('Submitting...');
  };

  const fields = { ...FIELDS };
  const type = watch('type');

  if ('feature' === type) {
    fields.subject = {
      ...fields.subject,
      label: 'In just a few words, what would you like to see added?',
    };

    fields.expectation = {
      ...fields.expectation,
      label: "Are there any details of what you'd expect to see?",
    };
  } else if ('comment' === type) {
    fields.subject = { ...fields.subject, label: 'Subject' };
    fields.expectation = { ...fields.expectation, label: 'Your comments' };
  } else {
    fields.bug = { ...fields.bug, type: 'string' };
  }

  return (
    <Modal title="Provide Feedback" setShow={setShow}>
      {submitting ? (
        <>
          <Text>{submitting}</Text>

          <Button label="Close" onPress={() => setShow(false)} wide />
        </>
      ) : (
        <>
          <Fields
            fields={fields}
            control={control}
            errors={errors}
          />

          <Button label="Submit" onPress={handleSubmit(onSubmit)} wide />
        </>
      )}
    </Modal>
  );
};

export default Ticket;
